<template>
  <div class="box">
    <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteFooterItem(item.id)"/>
    <b-input placeholder="Заголовок" @change="handleUpdate" v-model="item.title"/>
    <b-input placeholder="Ссылка" @change="handleUpdate" v-model="item.url"/>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'FooterItem',
    data () {
      return {
      }
    },
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions(['deleteFooterItem', 'updateFooterItem']),
      handleUpdate () {
        this.updateFooterItem(this.item)
      }
    }
  }
</script>

<style scoped>
.box {
  margin: 0;
  position: relative;
}
.control {
  margin: 0 0 10px;
}
.delete-icon {
  top: -10px;
  right: -10px;
}
</style>



// WEBPACK FOOTER //
// FooterItem.vue?0790073c